import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IFrontendConfig } from 'common_library';

const DEFAULT_FRONTEND_CONFIG: IFrontendConfig = {
  map: {
    provider: 'legacy',
    fallbackStyleUrl: 'https://tiles.eagleprojects.cloud/styles/basic-preview/style.json'
  }
};

@Injectable({ providedIn: 'root' })
export class FrontendConfigService {
  private configPromise: Promise<IFrontendConfig>;

  constructor(
    private http: HttpClient,
    @Inject('BACKEND_URL') private backendUrl: string
  ) { }

  getConfig(): Promise<IFrontendConfig> {
    if (!this.configPromise) {
      this.configPromise = this.http.get<IFrontendConfig>(this.endPoint('frontend-config')).toPromise().catch((err) => {
        console.log('Unable to load frontend-config, using defaults', err);
        return DEFAULT_FRONTEND_CONFIG;
      });
    }

    return this.configPromise;
  }

  private endPoint(ctrl: string): string {
    const apiUrl = `${this.backendUrl}/api`;
    const baseCtrl = apiUrl.trim().endsWith('/') ? apiUrl.trim() : `${apiUrl.trim()}/`;
    let _ctrl = ctrl.trim();
    _ctrl = _ctrl.startsWith('/') ? _ctrl.substring(1) : _ctrl;
    return `${baseCtrl}${_ctrl}`;
  }
}
